import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { CustomTableComponent } from "../../../shared/ui/custom-table/components/table/custom-table.component";


import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { LoanListComponent } from "./components/loan-list/loan-list.components";
import { LoanDetailComponent } from "./components/loan-detail/loan-detail.component";
import { LoanOperationDialogComponent } from "./components/loan-operation-dialog/loan-operation-dialog.component";
import { LoanAttachmentDialogComponent } from "./components/loan-attachment-dialog/loan-attachment-dialog.component";
import { LoanFormDialogComponent } from "./components/loan-form-dialog/loan-form-dialog.component";
import { SharedModule } from "../../shared/shared.module";
import {LoanReducer} from './store/reducers/loan.reducer'
import {LoanService} from './services/loan.service'
import {LoanEffects} from './store/effects/loan.effects'




@NgModule({
  declarations:[
    LoanListComponent,
    LoanDetailComponent,
    LoanOperationDialogComponent,
    LoanAttachmentDialogComponent,
    LoanFormDialogComponent
  ],
  exports:[
    LoanListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    RouterModule,
    FormsModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatDatepickerModule,

    // NgRx
    StoreModule.forFeature('loan', LoanReducer),
    EffectsModule.forFeature([LoanEffects])
  ],
  providers: [
    LoanService
  ]
})

export class LoanModule { }
